import ConfigView from "../ConfigView.vue";
import UserList from "../Pages/UserList.vue"
import UserEditor from "../Pages/UserEditor.vue"
import VehicleTypeList from "../Pages/VehicleTypeList.vue"
import VehicleTypeEditor from "../Pages/VehicleTypeEditor.vue"
import VehicleList from "../Pages/VehicleList.vue"
import VehicleEditor from "../Pages/VehicleEditor.vue"
import DriverList from "../Pages/DriverList.vue"
import DriverEditor from "../Pages/DriverEditor.vue"
import AffiliateList from "../Pages/AffiliateList.vue"
import AffiliateEditor from "../Pages/AffiliateEditor.vue"
import PassengerList from "../Pages/PassengerList.vue"
import PassengerEditor from "../Pages/PassengerEditor.vue"
import CategoryList from "../Pages/CategoryList.vue"
import CategoryEditor from "../Pages/CategoryEditor.vue"
import CouponList from "../Pages/CouponList.vue"
import CouponEditor from "../Pages/CouponEditor.vue"
import OtaList from "../Pages/OtaList.vue"
import DriverActivityPage from "../Pages/DriverActivityPage.vue"
import VehicleShiftsPage from "../Pages/VehicleShiftsPage.vue"
import DocumentTypeList from "../Pages/DocumentTypeList.vue"

const routes = [
  {
    path: '/mantenimiento',
    component: ConfigView,
    name: 'config',
    children: [
      {
        path: 'otas',
        name: 'config-ota-list',
        component: OtaList
      },
      {
        path: 'users',
        name: 'config-user-list',
        component: UserList
      },
      {
        path: 'users/create',
        name: 'config-user-create',
        component: UserEditor,
      },
      {
        path: 'users/:id/edit',
        name: 'config-user-edit',
        component: UserEditor,
      },
      {
        path: 'vehicles-type',
        name: 'config-vehicle-type-list',
        component: VehicleTypeList
      },
      {
        // DEF-ADM-019 — mantenedor de tipos de documento.
        path: 'document-types',
        name: 'config-document-type-list',
        component: DocumentTypeList
      },
      {
        path: 'vehicles-type/create',
        name: 'config-vehicle-type-create',
        component: VehicleTypeEditor
      },
      {
        path: 'vehicles-type/:id/edit',
        name: 'config-vehicle-type-edit',
        component: VehicleTypeEditor
      },
      {
        path: 'vehicles',
        name: 'config-vehicle-list',
        component: VehicleList
      },
      {
        path: 'vehicles/create',
        name: 'config-vehicles-create',
        component: VehicleEditor
      },
      {
        path: 'vehicles/:id/edit',
        name: 'config-vehicles-edit',
        component: VehicleEditor
      },
      // DEF-ADM-011 v2.0 — vistas de solo lectura. Path absoluto para conservar
      // la URL solicitada, renderizando dentro del layout de ConfigView.
      {
        path: '/vehiculos/:id/turnos',
        name: 'config-vehicle-shifts',
        component: VehicleShiftsPage
      },
      {
        path: '/conductores/:id/bitacora',
        name: 'config-driver-activity',
        component: DriverActivityPage
      },
      {
        path: 'drivers',
        name: 'config-driver-list',
        component: DriverList
      },
      {
        path: 'drivers/create',
        name: 'config-driver-create',
        component: DriverEditor
      },
      {
        path: 'drivers/:id/edit',
        name: 'config-drivers-edit',
        component: DriverEditor
      },
      {
        path: 'affiliates',
        name: 'config-affiliate-list',
        component: AffiliateList
      },
      {
        path: 'affiliates/create',
        name: 'config-affiliate-create',
        component: AffiliateEditor
      },
      {
        path: 'affiliates/:id/edit',
        name: 'config-affiliate-edit',
        component: AffiliateEditor
      },
      {
        path: 'passengers',
        name: 'config-passenger-list',
        component: PassengerList
      },
      {
        path: 'passengers/create',
        name: 'config-passenger-create',
        component: PassengerEditor
      },
      {
        path: 'passengers/:id/edit',
        name: 'config-passenger-edit',
        component: PassengerEditor
      },
      {
        path: 'categories',
        name: 'config-category-list',
        component: CategoryList
      },
      {
        path: 'categories/create',
        name: 'config-category-create',
        component: CategoryEditor
      },
      {
        path: 'categories/:id/edit',
        name: 'config-category-edit',
        component: CategoryEditor
      },
      {
        path: 'coupons',
        name: 'config-coupon-list',
        component: CouponList
      },
      {
        path: 'coupons/create',
        name: 'config-coupon-create',
        component: CouponEditor
      },
      {
        path: 'coupons/:id/edit',
        name: 'config-coupon-edit',
        component: CouponEditor
      }
    ]
  },
]

export default routes
